module.exports = __webpack_public_path__ + "img/video_consult_bg.ebd33483.png";